
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeDialog extends Serenity.EntityDialog<ProdottiEsperienzeRow, any> {
        protected getFormKey() { return ProdottiEsperienzeForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiEsperienzeRow.nameProperty; }
        protected getService() { return ProdottiEsperienzeService.baseUrl; }
        protected getDeletePermission() { return ProdottiEsperienzeRow.deletePermission; }
        protected getInsertPermission() { return ProdottiEsperienzeRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiEsperienzeRow.updatePermission; }

        protected form = new ProdottiEsperienzeForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // Questa gestisce l'editor.          
            this.form.EsperienzaClassiList.IdProdottoEsperienza = this.form.IdProdottoEsperienza.value;
            this.form.EsperienzaClassiList.IdProdottoEsperienza = this.form.IdProdottoEsperienza.value;

            // Questa gestisce l'editor.          
            // this.form.EsperienzaTaskList.IdProdottoEsperienza = this.form.IdProdottoEsperienza.value;
        }
    }
}